define('lq/services/action/actionServiceFactory',[
    'lq/typesProvider',

    './pasteCommand'
], function (TypesProvider) {
    'use strict';

    var servicesTypes = Array.prototype.slice.call(arguments, 1);
    var typesProvider = new TypesProvider(servicesTypes);

    var createService = function(service, rootDrop) {
        var ServiceType = typesProvider.get(service.serviceType);
        var instance = new ServiceType(service.data, rootDrop);
        return instance;
    };

    return {
        createService: createService
    };
});
